/**
 * Styles « pill » partagés pour les <Link> qui doivent ressembler aux Button
 * du design system (mêmes tokens, cible tactile ≥ 44px) tout en gardant la
 * sémantique de lien (navigation).
 */

export const pillPrimary =
  'inline-flex h-11 items-center justify-center rounded-full bg-panda-500 px-6 ' +
  'font-display font-semibold text-ink-950 shadow-glow-panda ' +
  'transition-[box-shadow,filter] duration-fast ease-fun hover:brightness-110';

export const pillSecondary =
  'inline-flex h-11 items-center justify-center rounded-full border border-ink-600 bg-ink-700 px-6 ' +
  'font-display font-semibold text-ink-100 ' +
  'transition-[box-shadow,border-color] duration-fast ease-fun hover:border-panda-500/60 hover:shadow-glow-panda';
